import { render, staticRenderFns } from "./DialogHistory.vue?vue&type=template&id=b5fffbaa"
import script from "./DialogHistory.vue?vue&type=script&lang=js"
export * from "./DialogHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports